import { SvgIcon, SvgIconProps } from '@mui/material'
import React from 'react'

export const FormatHeading:React.FC<SvgIconProps> = (props) => (
  <SvgIcon width="32" height="32" viewBox="0 0 32 32" {...props}>
    <path d="M21.7822 22H18.8525V15.9062H13.1396V22H10.21V7.78125H13.1396V13.543H18.8525V7.78125H21.7822V22Z" fill="currentColor" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
  </SvgIcon>
)
